/**
 * Skyyrizon Hero — cycling slideshow controller.
 * Behavior:
 *   - Auto-advances every `data-interval` ms (default 4000).
 *   - Crossfade between slides via CSS .is-active class.
 *   - Pauses on hover, when offscreen, when tab hidden, and if user prefers-reduced-motion.
 *   - Dots jump to a specific slide and restart the timer.
 */
(function () {
  'use strict';

  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sky-hero__slide'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('.sky-hero__dot'));
    if (slides.length < 2) return; // nothing to cycle

    var interval = parseInt(root.getAttribute('data-interval'), 10);
    if (!interval || interval < 1500) interval = 4000;

    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var current = 0;
    var timer = null;
    var hovered = false;
    var visible = true;

    function activate(index) {
      var next = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === next); });
      dots.forEach(function (d, i)   { d.classList.toggle('is-active', i === next); });
      current = next;
    }

    function step() {
      activate(current + 1);
    }

    function start() {
      if (prefersReducedMotion) return;
      if (hovered || !visible) return;
      stop();
      timer = window.setInterval(step, interval);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Dots → jump + restart
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        activate(i);
        start();
      });
    });

    // Pause on hover (desktop)
    root.addEventListener('mouseenter', function () { hovered = true;  stop(); });
    root.addEventListener('mouseleave', function () { hovered = false; start(); });

    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    // Pause when offscreen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) start(); else stop();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      start();
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sky-hero]');
    for (var i = 0; i < roots.length; i++) initHero(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
